<template>
    <div>
        <v-card-title>
            <span class="headline">Właściwości</span>
        </v-card-title>
        <v-text-field
            v-model="editable.max_length"
            :label="$t('materials.max_length')"
            :error-messages="fieldErrors('max_length')"
            type="number"
            @input="changeValue">
        </v-text-field>
    </div>
</template>
<script>
export default {
        name: "SlatForm",
        props: {
            item: {},
            errors: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                editable: {
                    max_length: 0,
                    name: ''
                }
            }
        },
        methods: {
            fieldErrors(field) {
                return this.errors['slat.' + field] || []
            },
            changeValue(event){
                this.editable.max_length = event
                this.editable.name = this.item.description.pl
                this.$emit('itemChange', this.editable)
            }
        },
        mounted() {
            if(this.item.slat)
            {
                this.editable = this.item.slat

            }
            this.changeValue(this.editable.max_length)
        },

}
</script>
